import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = state.products.find((item) => item.id === action.payload.id);

      if (item) {
        item.quantity += action.payload.quantity;
      } else {
        state.products.push(action.payload);
      }
    },
    removeItem: (state, action) => {
      state.products = state.products.filter(
        (item) => item.id !== action.payload
      );
    },
    resetCart: (state) => {
      state.products = [];
    },
    updateQuantity: (state, action) => {
      const item = state.products.find(
        (product) => product.id === action.payload.id
      );
      if (item) {
        if (action.payload.quantity !== undefined) {
          item.quantity = action.payload.quantity;
        }
        if (action.payload.price !== undefined) {
          item.price = action.payload.price;
        }
      }
    },
    validateCart: (state) => {
      const now = new Date();

      state.products.forEach((item) => {
        if (
          item.flashSale === "yes" &&
          item.flashEndDate &&
          item.flashEndTime
        ) {
          const flashEndDateTime = new Date(
            `${item.flashEndDate}T${item.flashEndTime}:00`
          );

          if (!isNaN(flashEndDateTime) && flashEndDateTime < now) {
            item.price = item.originalPrice;
            item.flashSale = "no";
          }
        }
      });
    },
  },
});

export const {
  addToCart,
  removeItem,
  resetCart,
  updateQuantity,
  validateCart,
} = cartSlice.actions;

export default cartSlice.reducer;
